import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PageSize, Orientation, MapScale, GridSize } from './exportTypes';

// Serializable version of LatLng for Redux store
interface SerializableLatLng {
    lat: number;
    lng: number;
}

interface SerializableBounds {
    southWest: SerializableLatLng;
    northEast: SerializableLatLng;
}

interface ExportState {
    pageSize: PageSize;
    orientation: Orientation;
    scale: MapScale;
    gridSize: GridSize;
    showExportRect: boolean;
    isExporting: boolean;
    // Current viewport bounds (from the blue rectangle)
    viewportBounds: SerializableBounds | null;
}

const initialState: ExportState = {
    pageSize: 'A4',
    orientation: 'landscape',
    scale: '1:25000',
    gridSize: '1km',
    showExportRect: false,
    isExporting: false,
    viewportBounds: null,
};

export const exportSlice = createSlice({
    name: 'export',
    initialState,
    reducers: {
        setPageSize: (state, action: PayloadAction<PageSize>) => {
            state.pageSize = action.payload;
        },
        setOrientation: (state, action: PayloadAction<Orientation>) => {
            state.orientation = action.payload;
        },
        setScale: (state, action: PayloadAction<MapScale>) => {
            state.scale = action.payload;
        },
        setGridSize: (state, action: PayloadAction<GridSize>) => {
            state.gridSize = action.payload;
        },
        setShowExportRect: (state, action: PayloadAction<boolean>) => {
            state.showExportRect = action.payload;
        },
        setIsExporting: (state, action: PayloadAction<boolean>) => {
            state.isExporting = action.payload;
        },
        setViewportBounds: (state, action: PayloadAction<SerializableBounds | null>) => {
            state.viewportBounds = action.payload;
        },
    },
});

export const {
    setPageSize,
    setOrientation,
    setScale,
    setGridSize,
    setShowExportRect,
    setIsExporting,
    setViewportBounds,
} = exportSlice.actions;

export default exportSlice.reducer;
